import { render, staticRenderFns } from "./GiftCard.vue?vue&type=template&id=9534656e&scoped=true"
import script from "./GiftCard.vue?vue&type=script&lang=js"
export * from "./GiftCard.vue?vue&type=script&lang=js"
import style0 from "./GiftCard.vue?vue&type=style&index=0&id=9534656e&prod&lang=css"
import style1 from "./GiftCard.vue?vue&type=style&index=1&id=9534656e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9534656e",
  null
  
)

export default component.exports